module.exports = __webpack_public_path__ + "img/20.bbc17b45.webp";